module.exports = __webpack_public_path__ + "static/media/por_ti_program.7fa1ad9d.png";